import { useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";

import AgentPasswordDialog from "./AgentPasswordDialog";
import {
    getAgentToken,
    clearAgentToken,
} from "@/services/agentAccess";

export default function ProtectedAgent({
    agent,
    children,
}) {
    const [unlocked, setUnlocked] = useState(false);
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        const token = getAgentToken(agent);

        if (!token) {
            setUnlocked(false);
            setChecking(false);
            return;
        }

        try {
            const payload = jwtDecode(token);

            // Token expired
            if (payload.exp && payload.exp * 1000 < Date.now()) {
                clearAgentToken(agent);
                setUnlocked(false);
            } else {
                setUnlocked(true);
            }
        } catch (err) {
            console.error("Invalid agent token:", err);
            clearAgentToken(agent);
            setUnlocked(false);
        }

        setChecking(false);
    }, [agent]);

    if (checking) {
        return null;
    }

    return (
        <>
            {!unlocked && (
                <AgentPasswordDialog
                    open={true}
                    agent={agent}
                    onSuccess={() => setUnlocked(true)}
                />
            )}

            {unlocked && children}
        </>
    );
}